/*
 * @Author: luting
 * @Date: 2022-05-09 14:16:14
 * @lastEditors: luting
 * @LastEditTime: 2023-04-24 11:15:52
 */
import request from 'root/utils/request';
import { INetworkCardParams } from 'root/components/NetworkCard/types';
import { IPlatformTimeParams } from 'root/components/EditSysTime/types';

// 获取网卡列表
export const getNetworkApi = async (params: { clientIds: string[]; labels: string[] }) => {
  return request.post('/api/ops-manager/v1/server/node/nic/info', params);
};

// 修改网卡信息
export const updateNetworkApi = async (data: INetworkCardParams) => {
  return request({
    method: 'POST',
    url: `/api/ops-manager/v1/server/node/nic/modify`,
    data,
  });
};

// 获取所有时区
export const getAllTimeZoneApi = async () => {
  return request.get('/api/ops-manager/v1/supos/platform/timezones');
};

// 修改系统时间
export const updatePlatformTimeApi = async (data: IPlatformTimeParams) => {
  return request({
    method: 'POST',
    url: `/api/ops-manager/v1/supos/platform/time`,
    data,
  });
};

// 扩容节点
export const updatNode = async (data: any) => {
  return request({
    method: 'POST',
    url: `/api/ops-manager/v1/supos/platform/time`,
    data,
  });
};

// 获取可扩容主机列表
export const getHostseApi = async () => {
  return request.get('/api/ops-manager/v1/supos/platform/timezones');
};

// 获取可扩容节点类型
export const getNodeTypeListApi = async () => {
  return request.get('/api/ops-manager/v1/supos/platform/timezones');
};

// 重启网卡服务
export const restartServiceApi = async (params: { clientIds: string[]; labels: string[] }) => {
  return request.post('/api/ops-manager/v1/supos/platform/network/restart', params);
};
